import './App.css';
import React from 'react';
function Footer(){
    return (
        <div className='footer'><h4>@sumithra</h4></div>
    )
}

export default Footer;